import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadConfig } from './utils/config';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Primero config.json (window.config) y después React: login, navbar y tarifas leen
// window.config al renderizar y no se vuelven a pintar cuando llega.
loadConfig()
  .catch((error) => console.error('No se ha podido cargar config.json:', error))
  .finally(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
